module.exports = __webpack_public_path__ + "img/Group4_26sp.4b47da52.jpg";